import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  buyList: [],
  emoticonList: [],
  buy: {
    userNo: '',
    emoticonNo: ''
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
